import { ChartsAssessmentScoresTotals } from 'district-ui-client/components/charts/assessment-scores/totals'
import { DetailedPageWrapper } from 'district-ui-client/components/reporting/detailed-page-wrapper'
import { not } from 'ember-truth-helpers'
import fullGradeName from 'district-ui-client/helpers/full-grade-name'
import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import type ReQuizzesCompletedRoute from 'district-ui-client/reporting/ui-scope/re/quizzes-completed/route'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<ReQuizzesCompletedRoute>
  }
}

export const ReQuizzesCompletedRouteTemplate: TOC<Signature> = <template>
  <DetailedPageWrapper @empty={{not @model.assessmentScoresTotals}}>
    {{#each @model.assessmentScoresTotals as |gradeData|}}
      <div class="detailed-chart-wrapper">
        <ChartsAssessmentScoresTotals
          class="h-full"
          @data={{gradeData}}
          @product={{@model.product}}
          @grade={{fullGradeName gradeData.grade_position}}
          @tooltip={{t "reporting.tooltips.assessmentScoresTotals"}}
          @title={{t "reporting.chartTitles.assessmentScoresTotals.re"}}
        />
      </div>
    {{/each}}
  </DetailedPageWrapper>
</template>

export default RouteTemplate(ReQuizzesCompletedRouteTemplate)
